import { HttpContextToken, HttpRequest } from '@angular/common/http';

export const SkipByAuthInterceptor = new HttpContextToken(() => true);

export const isSkippedByAuth = <Body>(request: HttpRequest<Body>): boolean => {
  return request.context.has(SkipByAuthInterceptor);
};
